import { usePage } from '@inertiajs/react'

interface TranslationMap {
  [key: string]: string | TranslationMap
}

interface LocalePageProps {
  locale: string
  locales: string[]
  translations: TranslationMap
  localePrefix: string
}

function dig(obj: TranslationMap, path: string): string {
  const keys = path.split('.')
  let current: string | TranslationMap = obj

  for (const key of keys) {
    if (typeof current !== 'object' || current === null) return path
    current = (current as TranslationMap)[key]
    if (current === undefined) return path
  }

  return typeof current === 'string' ? current : path
}

export function useTranslation() {
  const { props } = usePage()
  const { locale, locales, translations, localePrefix } = props as unknown as LocalePageProps

  const currentLocale = locale || 'it'
  const availableLocales = locales || ['en', 'it']
  const t = (key: string): string => {
    if (!translations) return key
    return dig(translations as TranslationMap, key)
  }
  const prefix = localePrefix || ''

  /** Build a localized path for a given locale */
  const localePath = (path: string, targetLocale?: string): string => {
    const loc = targetLocale || currentLocale
    if (loc === 'it') return path
    return `/${loc}${path}`
  }

  /** Build a localized path preserving current locale */
  const lp = (path: string): string => {
    return localePath(path)
  }

  return {
    t,
    locale: currentLocale,
    locales: availableLocales,
    localePrefix: prefix,
    localePath,
    lp,
  }
}
